import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import SEO from '../components/SEO';
import {
  FaHome, FaUserAlt, FaRoute, FaBriefcase, FaGavel, FaPenNib, FaPodcast,
  FaFileContract, FaCompass, FaFolderOpen, FaHandshake, FaComments, FaShieldAlt,
} from 'react-icons/fa';
import '../Styles/Sitemap.css';

const SECTIONS = [
  {
    title: 'Start here',
    links: [
      { to: '/', label: 'Home', desc: 'The PP Studio at a glance', icon: <FaHome /> },
      { to: '/know-me', label: 'About Me', desc: "Pooja's background and approach", icon: <FaUserAlt /> },
      { to: '/journey', label: 'Journey', desc: 'How the practice came to be', icon: <FaRoute /> },
      { to: '/skills', label: 'Skills', desc: 'Expertise and areas of focus', icon: <FaBriefcase /> },
      { to: '/cases', label: 'Cases', desc: 'Selected work and outcomes', icon: <FaGavel /> },
    ],
  },
  {
    title: 'Reading',
    links: [
      { to: '/blog', label: 'The PP Edit', desc: 'Essays on contracts, freelancing, and business', icon: <FaPenNib /> },
      { to: '/contract-tips', label: 'Contract Tips', desc: 'Short, practical notes worth bookmarking', icon: <FaFileContract /> },
      { to: '/podcast', label: 'Podcast', desc: 'Conversations on contracts and craft', icon: <FaPodcast /> },
    ],
  },
  {
    title: 'Free tools',
    links: [
      { to: '/contract-compass', label: 'Contract Compass', desc: 'Upload a contract, get an instant AI breakdown', icon: <FaCompass /> },
      { to: '/desk/signup', label: 'Contract Desk', desc: 'Keep every contract, deadline, and obligation in one place', icon: <FaFolderOpen /> },
      { to: '/guidance', label: 'Free Sessions', desc: "Pooja's free 30-minute guidance sessions", icon: <FaComments /> },
    ],
  },
  {
    title: 'Work together',
    links: [
      { to: '/work-with-me', label: 'Work With Me', desc: 'Paid contract review, drafting, and negotiation support', icon: <FaHandshake /> },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Policy', desc: 'How your data is handled across the site', icon: <FaShieldAlt /> },
    ],
  },
];

export default function Sitemap() {
  return (
    <>
      <SEO
        title="Site Map | The PP Studio"
        description="Every page on The PP Studio — Pooja Biswal's contract specialist practice — in one place: reading, free tools, and ways to work together."
        url="https://pp-studio-website.web.app/sitemap"
      />
      <Navbar />

      <main className="sm-main">
        <section className="sm-hero">
          <span className="sm-kicker"><i /> Site Map</span>
          <h1>Find your way<br /><em>around The PP Studio.</em></h1>
          <p>Everything on the site, in one place — reading, free tools, and ways to work with Pooja directly.</p>
        </section>

        <section className="sm-body">
          <div className="sm-grid">
            {SECTIONS.map(section => (
              <div className="sm-section" key={section.title}>
                <h2>{section.title}</h2>
                <ul>
                  {section.links.map(link => (
                    <li key={link.to}>
                      <Link to={link.to}>
                        <span className="sm-icon">{link.icon}</span>
                        <span className="sm-link-copy">
                          <strong>{link.label}</strong>
                          <span>{link.desc}</span>
                        </span>
                        <span className="sm-arrow">&rarr;</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
